import React from 'react';

import { type TGlobalFunctionTyped } from '../../../../../common/hooks/useTranslation';
import type {
  AnalyticalFieldAssociationAutomation,
  ExpenseAccountAutomation,
  VatAccountAutomation,
} from '../../../../payable';
import { AutomationIcon } from '../../../../payable/components/AutomationIcon';

type Props = {
  automation:
    | AnalyticalFieldAssociationAutomation
    | ExpenseAccountAutomation
    | VatAccountAutomation
    | undefined;
  translationKey: string;
  t: TGlobalFunctionTyped;
};

export const PayableAccountingSectionDetailLine: React.FunctionComponent<
  Props
> = ({ translationKey, t, automation }: Props) => {
  if (!automation) {
    return translationKey;
  }

  const isRuleBased = automation.kind === 'ruleBased';

  return automation.isAppliedOnPayable && isRuleBased ? (
    <LineWithAutomation
      {...{
        translationKey,
        t,
        automation,
      }}
    />
  ) : (
    translationKey
  );
};

const LineWithAutomation: React.FunctionComponent<
  Props & { automation: Exclude<Props['automation'], undefined> }
> = ({
  translationKey,
  t,
  automation,
}: Props & { automation: Exclude<Props['automation'], undefined> }) => {
  return (
    <span>
      {t(translationKey as Parameters<TGlobalFunctionTyped>[0])}
      <span
        style={{
          paddingLeft: 4,
          verticalAlign: 'middle',
          display: 'inline-block',
        }}
      >
        <AutomationIcon
          automation={automation}
          rule={'rule' in automation ? automation.rule : undefined}
          t={t}
        />
      </span>
    </span>
  );
};
